import React from 'react';
import Report from 'common/components/report';
import CurrenciesPrMonthReport from 'finance/currenciesPrMonthReport/currenciesPrMonthReport.js';

function CurrenciesPrMonthPage() {
	return <Report report={CurrenciesPrMonthReport} />;
}

export default CurrenciesPrMonthPage;
